// js-JP
export default {
	title: "ギフトカードセンター",
	myPoints: "マイポイント",
	SelectedGifts: "選択されたギフト",
	form: {
		label: {
			title: "検索",
			points: "ポイント"
		}
	},
	redemption: "償還",
	stock: "ストック",
	id: {
		redeemPoints: "必要なポイントを交換する：",
		btn: "今すぐ交換",
		title: "購入のお知らせ",
		content: `作業員の皆様、作業にご参加いただきありがとうございます。\n\nポイントを引き換える前に次の規約をお読みください:\n\n[作業ポイント] 注文セット データの最適化が毎日完了すると、作業者は 1 ギフト ポイントを獲得できます。 ギフト スポンサーシップの一部の引き換えに使用できます。\n[ギフトの引き換え] 従業員は関連する配送先住所情報を提供する必要があります。ギフトは 14 日以内に世界中に無料で発送されます。 引き換えが完了したら、カスタマー サービスに連絡して、ギフトの進行状況を追跡するための追跡番号を取得できます。 プラットフォームが第三者に情報を開示することはありません。\n注: ポイントをギフトと引き換えると、返金することはできません。`
	},
	applyDialog: {
		title: "情報受信",
		form: {
			consignee: "受取人",
			area: "エリア",
			telephone: "電話番号",
			deliveryAddress: "配送先住所"
		},
		btn: "提出する"
	},
	records: {
		title: "記録",
		status: ["未発送", "発送済み", "配達済み", "キャンセル"]
	}
};
